import { toast } from 'react-toastify';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import {
  COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_BEGIN,
  COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_SUCCESS,
  COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_FAILURE,
  COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function createDerivedFieldMappingInCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_BEGIN,
    });
    const { projectId, version, data, selectedCollection } = args;
    const { uuid: collectionUuid } = selectedCollection;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/utilties/${collectionUuid}/collection/create-derived-field-mapping`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created Derived Field Mapping in Collection');
          toast.success('Created Successfully !');
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create derived field mapping in collection');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateDerivedFieldMappingInCollectionError() {
  return {
    type: COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_BEGIN:
      return {
        ...state,
        createDerivedFieldMappingInCollectionPending: true,
        createDerivedFieldMappingInCollectionError: null,
      };

    case COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_SUCCESS:
      return {
        ...state,
        createDerivedFieldMappingInCollectionPending: false,
        createDerivedFieldMappingInCollectionError: null,
        derivedFieldMapping: action.data.derivedFieldMapping || [],
      };

    case COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_FAILURE:
      return {
        ...state,
        createDerivedFieldMappingInCollectionPending: false,
        createDerivedFieldMappingInCollectionError: action.data.error,
      };

    case COLLECTIONS_CREATE_DERIVED_FIELD_MAPPING_IN_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        createDerivedFieldMappingInCollectionError: null,
      };

    default:
      return state;
  }
}
